export default "__VITE_ASSET__Cpp$DgtY__"